import EnterpriseLayout from "./EnterpriseLayout";
import { EnterpriseHero } from "./components/EnterpriseHero";
import { EnterpriseEcosystem } from "./components/EnterpriseEcosystem";
import { EnterpriseSecurity } from "./components/EnterpriseSecurity";
import { EnterpriseContact } from "./components/EnterpriseContact";
import { ENTERPRISE_LINKS } from "./enterpriseLinks";

export default function Enterprise() {
  return (
    <EnterpriseLayout
      title="Rentid Enterprise — Mobility platform and marketplace APIs"
      description="Build, protect, verify, and automate your rental operation with RentShield, RentID, and RentSuccess — Rentid's enterprise products for mobility operators."
      path={ENTERPRISE_LINKS.home}
    >
      <EnterpriseHero />
      <EnterpriseEcosystem />
      <EnterpriseSecurity />
      <EnterpriseContact />
    </EnterpriseLayout>
  );
}
